export default "__VITE_ASSET__a30a8fa2__"